import React, { Component } from 'react'
import { Modal, Button } from 'antd'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class ChooseClientPagePopup extends Component<any, any> {
    render() {
        const {  
            popupStore: { popupType, info, togglePopup },
            history
        } = this.props
        const footerButtons = (
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center'
                }}
            >
                <Button onClick={() => togglePopup(false)}>סגור</Button>
            </div>
        )
        return (
            <Modal
                title={'בחירת דף משתמש לתצוגה'}
                visible={popupType === 'chooseClientPopup'}
                cancelText="ביטול"
                onCancel={() => togglePopup(false)}
                footer={footerButtons}
                width={450}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        flex: 1,
                        alignItems: 'center',
                        height: '100%'
                    }}
                >
                    <Button
                        style={{ width: '42%' }}
                        onClick={() => {
                            history.push(`/clients/${info}`)
                        }}
                    >
                        לקוח
                    </Button>
                    <Button
                        style={{ width: '42%' }}
                        onClick={() => {
                            history.push(`/agents/${info}`)
                        }}
                    >
                        סוכן
                    </Button>
                </div>
            </Modal>
        )
    }
}

export default withRouter(ChooseClientPagePopup)
